import getApiData from "@/api/apiUtil";
import {post} from "@/utils/request";
import apiConfig from "@/api/config";

const state = {
  bk_config_logo: '',
  bk_config_login_logo: '',
  bk_config_signin_logo: '',
  bk_config_mp_qrcode: '',
  bk_config_tel: '',
  bk_config_tel_time: '',
  bk_config_copyright: '',
  bk_config_beian: '',
  bk_config_web_title: '',
  bk_config_web_title_en: '',
  bk_vip_description: '',
  bk_supplier_vip_description: '',
  bk_user_description:'',
  bk_supplier_description:'',
  bk_chooser_description:'',
}

const mutations= {
  SET_CONFIG: (state, config) => {
    Object.assign(state, config)
  }
}

const actions= {
  async initConfig({commit}){
    let config = await getApiData(apiConfig.commonConfig())
    commit('SET_CONFIG', config)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
